import { useMemo } from "react";
import { ApolloError, useSuspenseQuery } from "@apollo/client";

import { LegacyRoutes } from "@/helpers/LegacyRoutes";
import { useDossierContext } from "./dossierContext";
import { BaseDataQuery } from "./sessionQueries";

export const useBaseData = () => {
  const { organizationKey, dossierId } = useDossierContext();

  const { data, error } = useSuspenseQuery(BaseDataQuery, {
    variables: { organizationKey, dossierId },
    errorPolicy: "none",
    fetchPolicy: "cache-first",
  });

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error("No data");
  }

  return data;
};

const useLegacyRoutes = () => {
  const {
    organization: { url },
    dossier: { id },
  } = useBaseData();
  const legacyRoutes = useMemo(() => new LegacyRoutes(url, id), [url, id]);
  return legacyRoutes;
};

const useCurrentUser = () => {
  const { session } = useBaseData();

  if (!session.user || session.user.__typename !== "Professional") {
    throw new ApolloError({ errorMessage: "Current user is not a professional" });
  }

  return session.user;
};

export const useSessionContext = () => {
  const data = useBaseData();
  const legacyRoutes = useLegacyRoutes();
  const user = useCurrentUser();

  return {
    ...data,
    user,
    legacyRoutes,
    environment: data.session.environment,
    organizationKey: data.organization.key,
    dossierId: data.dossier.id,
    locale: data.session.locale,
  };
};
